import Validator from '@croco/validator'
import Sync from '@croco/sync'
import di from 'dependeny-injection';
import Emitter     from 'es6-event-emitter';

class Inquiry extends Emitter{
    /**
     * コンストラクタ
     *
     * @access public
     * @return void
     */
    constructor() {
        super();
        this.sync = new Sync();
        this.csrfToken = document.querySelector("meta[name=csrf-token]").getAttribute("content");
       
        this.apiPath = '/inquiry';

        this.coreData = new Validator({
            name: '',
            email: '',
            content: '',
            agree: ''
        });
        this.beforeunload_is_set = false;
    }
    
    setChanger(fn) {
        this.on("tag:change", fn);
    }
    changeLoaderState(state, childObject = null, name) {
        di.loader.setState(state);
        if (childObject) {
            childObject[name] = state;
            childObject.update();
        }
    }

    tag(param){
        this.trigger('tag:change', param);
    }

    api(path, data) {
        data['csrf-token'] = this.csrfToken;
        return this.sync.post(this.apiPath + path, data);
    }

    beforeunload(e) {
        e.preventDefault();
        e.returnValue = '未保存のデータがありますが、本当に閉じますか？';
    }

    lockUnload(){
        if (this.beforeunload_is_set) return;

        this.beforeunload_is_set = true;
        window.addEventListener('beforeunload', this.beforeunload, false);
    }

    unlockUnload(){
        window.removeEventListener('beforeunload', this.beforeunload, false);
        this.beforeunload_is_set = false;
    }

} // class Inquiry

// 確実に呼び出されるオブジェクト
di.set('inquiry', new Inquiry());
